import { Dictionary } from '@feedyou/schema'
import _ from 'lodash'

export const getDefaultStopwords = (locale: string) =>
  getEnvDefaultStopwords(locale) || DEFAULT_STOPWORDS_BY_LOCALE[locale]

const getEnvDefaultStopwords = (locale: string) => {
  const param = 'FeedbotNlpDefaultStopwords' + _.capitalize(locale)
  return process.env[param] ? process.env[param].split(',') : null
}

const DEFAULT_STOPWORDS_BY_LOCALE: Dictionary<string, string[]> = {
  cs: [
    'a',
    'aby',
    'aj',
    'ale',
    'anebo',
    'ani',
    'aniž',
    'asi',
    'aspoň',
    'atd',
    'atp',
    'az',
    'ačkoli',
    'až',
    'ci',
    'co',
    'coz',
    'což',
    'cz',
    'do',
    'děkovat',
    'děkujeme',
    'děkuji',
    'ho',
    'i',
    'jak',
    'jakmile',
    'jako',
    'jakož',
    'jeho',
    'jehož',
    'jej',
    'jeji',
    'jejich',
    'její',
    'jelikož',
    'jemu',
    'jen',
    'jenom',
    'jenž',
    'jestli',
    'jestliže',
    'jež',
    'ji',
    'jich',
    'jimi',
    'jiz',
    'již',
    'já',
    'jí',
    'jím',
    'jíž',
    'k',
    'kam',
    'každý',
    'kde',
    'kdo',
    'kdy',
    'kdyz',
    'když',
    'ke',
    'kromě',
    'ktera',
    'ktere',
    'kteri',
    'kterou',
    'ktery',
    'která',
    'které',
    'který',
    'kteři',
    'kteří',
    'ku',
    'kvůli',
    'me',
    'mezi',
    'mi',
    'mit',
    'mne',
    'mnou',
    'mně',
    'moc',
    'možná',
    'my',
    'málo',
    'mé',
    'mí',
    'mít',
    'mě',
    'můj',
    'může',
    'na',
    'nad',
    'nade',
    'nam',
    'nas',
    'nasi',
    'načež',
    'naše',
    'naši',
    'nebo',
    'nechť',
    'nedělají',
    'nedělá',
    'nedělám',
    'neděláme',
    'neděláte',
    'neděláš',
    'neg',
    'nemáme',
    'nemáte',
    'neměl',
    'neni',
    'není',
    'nestačí',
    'nevadí',
    'nez',
    'než',
    'nich',
    'nimi',
    'no',
    'noo',
    'ná',
    'nám',
    'námi',
    'nás',
    'náš',
    'ní',
    'ním',
    'něco',
    'nějak',
    'někde',
    'někdo',
    'němu',
    'němuž',
    'o',
    'od',
    'ode',
    'on',
    'ona',
    'oni',
    'ono',
    'ony',
    'pak',
    'po',
    'pod',
    'podle',
    'pokud',
    'potom',
    'pouze',
    'pozdě',
    'pořád',
    'prave',
    'pravé',
    'pred',
    'pres',
    'pri',
    'pro',
    'proc',
    'prostě',
    'prosím',
    'proti',
    'proto',
    'protoze',
    'protože',
    'proč',
    'práve',
    'pta',
    'před',
    'přede',
    'přes',
    'přese',
    'při',
    'přičemž',
    're',
    'rovně',
    's',
    'se',
    'si',
    'sice',
    'skoro',
    'snad',
    'spolu',
    'sve',
    'svych',
    'svym',
    'svymi',
    'své',
    'svých',
    'svým',
    'svými',
    'svůj',
    'ta',
    'tady',
    'tak',
    'take',
    'takhle',
    'taky',
    'takze',
    'také',
    'takže',
    'tam',
    'tamhle',
    'tamhleto',
    'tamto',
    'tato',
    'te',
    'tebe',
    'tebou',
    "ted'",
    'tedy',
    'tema',
    'ten',
    'tento',
    'teto',
    'ti',
    'tim',
    'timto',
    'to',
    'tobě',
    'tohle',
    'toho',
    'tohoto',
    'tom',
    'tomto',
    'tomu',
    'tomuto',
    'toto',
    'trošku',
    'tu',
    'tuto',
    'tvoje',
    'tvá',
    'tvé',
    'tvůj',
    'ty',
    'tyto',
    'této',
    'tím',
    'tímto',
    'tě',
    'těm',
    'těma',
    'těmu',
    'třeba',
    'u',
    'uz',
    'už',
    'v',
    'vam',
    'vas',
    'vase',
    'vaše',
    'vaši',
    've',
    'vedle',
    'vlastně',
    'vsak',
    'vy',
    'vám',
    'vámi',
    'vás',
    'váš',
    'však',
    'z',
    'za',
    'zatímco',
    'zač',
    'zda',
    'zde',
    'ze',
    'zpet',
    'zpět',
    'či',
    'že',
    '_'
  ].map(stripDiacritics),
  sk: [
    'a',
    'aby',
    'aj',
    'ak',
    'ako',
    'ale',
    'alebo',
    'ani',
    'asi',
    'aspoň',
    'atď',
    'a podobne',
    'atp',
    'až',
    'bez toho',
    'aby',
    'čo',
    'sk',
    'ďakujem',
    'ďakujeme',
    'ďakovať',
    'ho',
    'i',
    'ich',
    'ja',
    'jej',
    'jeho',
    'jemu',
    'len',
    'ktorý',
    'ju',
    'nimi',
    'už',
    'ním',
    'ktorou',
    'k',
    'kam',
    'každý',
    'kde',
    'kto',
    'kedy',
    'keď',
    'okrem',
    'ktorá',
    'ktoré',
    'ktorí',
    'ktorú',
    'ktorý',
    'kvôli',
    'ma',
    'medzi',
    'mi',
    'mať',
    'mňa',
    'mnou',
    'mne',
    'veľa',
    'možno',
    'my',
    'málo',
    'moje',
    'moji',
    'môj',
    'môže',
    'na',
    'nad',
    'nám',
    'nás',
    'naši',
    'po tom',
    'čo',
    'naše',
    'nie',
    'nech',
    'nerobia',
    'nerobí',
    'nerobím',
    'nerobíme',
    'nerobíte',
    'nerobíš',
    'neg',
    'nemáme',
    'nemáte',
    'nemal',
    'nie je',
    'nestačí',
    'nevadí',
    'než',
    'nich',
    'no',
    'náš',
    'ňu',
    'niečo',
    'nejako',
    'niekde',
    'niekto',
    'nemu',
    'o',
    'od',
    'on',
    'ona',
    'oni',
    'ono',
    'ony',
    'potom',
    'po',
    'pod',
    'podľa',
    'iba',
    'neskoro',
    'stále',
    'práve',
    'pred',
    'cez',
    'pri',
    'pre',
    'prečo',
    'proste',
    'prosím',
    'proti',
    'preto',
    'pretože',
    'práve',
    'pýta',
    'rovno',
    's',
    'sa',
    'si',
    'síce',
    'skoro',
    'snáď',
    'spolu',
    'svoje',
    'svojich',
    'svojím',
    'svojimi',
    'svoj',
    'tá',
    'tu',
    'tak',
    'tiež',
    'takto',
    'takže',
    'tam',
    'tamto',
    'táto',
    'teba',
    'tebou',
    'teraz',
    'teda',
    'témami',
    'ten',
    'tento',
    'ti',
    'tým',
    'týmto',
    'to',
    'tebe',
    'toto',
    'toho',
    'tohto',
    'tom',
    'tomto',
    'tomu',
    'tomuto',
    'trošku',
    'tu',
    'túto',
    'tvoje',
    'tvoja',
    'tvoj',
    'ty',
    'tieto',
    'tejto',
    'tým',
    'ťa',
    'týmto',
    'napríklad',
    'u',
    'už',
    'v',
    'vám',
    'vás',
    'vaše',
    'vaši',
    'vo',
    'vedľa',
    'vlastne',
    'však',
    'vy',
    'vami',
    'váš',
    'z',
    'za',
    'zatiaľ čo',
    'za čo',
    'či',
    'zo',
    'späť',
    'že'
  ].map(stripDiacritics)
}

function stripDiacritics(input: string) {
  return input.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}
